import React, { Component } from "react";
import {
  SelectField,
  MenuItem,
  Card,
  FlatButton,
  Divider,
  CardTitle,
  Dialog,
  TextField,
  IconButton,
  Table,
  TableHeader,
  TableBody,
  TableRowColumn,
  Menu,
  Checkbox,
} from "material-ui";
import Loading from "../Loading";
import { Link } from "react-router";
import {
  FormsyRadioGroup,
  FormsyRadio,
  FormsyText,
  FormsyCheckbox,
} from "formsy-material-ui/lib";
import Formsy from "formsy-react";
import Dropzone from "react-dropzone";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import deleteDefaultIcon from "../../images/delete_default.png";
import editDefaultIcon from "../../images/edit_default.png";
import importDefaultIcon from "../../images/import_default.png";
import AddNewDocumentType from "./AddNewDocumentType";
import CreateMailingList from "./CreateMailingList";
import CreateMailingListIcon from "../../images/create_mailing_list.png";
import backIcon from "../../images/back.png";
import checkedIcon from "../../images/checked.png";
import addArrowIcon from "../../images/add_arrow.png";
import { sendgridTemplateList } from "../helpers.js";
import searchIcon from "../../images/search.png";
import ReactTooltip from "react-tooltip";

export default class ShowMailingList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "Click to upload file, or drag and drop file",
      open: false,
      openDeleteConfirmPopup: false,
      currentSelectedRow: {},
      value: "",
      note: "",
      name: "",
      selectedEmailTemplate: "",
      isDocumentTypeCheck: false,
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "75%",
        },
        zone: {
          width: "100%",
          height: "300px",
          border: "3px dashed #ebeff2",
        },
        activeZone: {
          width: "100%",
          height: "300px",
          border: "3px dashed green",
          backgroundColor: "Aquamarine",
        },
        zoneText: {
          textAlign: "center",
          fontSize: "2em",
        },
      },
      selectedRow: [],
      data: "",
      docValue: "",
      fileList: "",
      isLoading: false,
      response: "",
      searchValue: "",
      searchTextValue: "",
      mailingTypeList: [],
      createMailingListFlag: false,
      mailingTypeUserList: [],
      mailingTypeData: {},
    };
    this.editButtonFormatter = this.editButtonFormatter.bind(this);
    this.deleteButtonFormatter = this.deleteButtonFormatter.bind(this);
    this.submitSearchForm = this.submitSearchForm.bind(this);
    this.checkButtonFormatter = this.checkButtonFormatter.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.showMailingListMethod = this.showMailingListMethod.bind(this);
  }

  componentWillReceiveProps(props) {
    if (Object.keys(props.data).length != 0) {
      this.setState({
        name: props.data.name,
        note: props.data.note,
        selectedEmailTemplate: props.data.emailTemplateId,
        docValue: props.docValue,
      });
      this.selectedGroupOnEdit(props.data.groupList);
    } else {
      this.setState({
        name: "",
        note: "",
        selectedEmailTemplate: "",
        docValue: "",
      });
      this.selectedGroupOnEdit([]);
    }
  }

  notifyFormError(data, msg) {
    alert(msg);
  }

  selectedGroupOnEdit(groupList) {
    let selectedRow = [];
    groupList.forEach(function (groupObj) {
      selectedRow.push(groupObj._id);
    });
    this.setState({ selectedRow: selectedRow });
  }

  showCreateMailing = () => {
    this.setState({ createMailingListFlag: true });
  };

  deleteMailingTypeListUser = (row) => {
    this.setState({ openDeleteConfirmPopup: true, currentSelectedRow: row });
  };

  closeDeleteConfirmPopup = () => {
    this.setState({ openDeleteConfirmPopup: false, currentSelectedRow: {} });
  };

  deleteMailingType = () => {
    let { currentSelectedRow } = this.state;
    this.props.deleteMailingList(currentSelectedRow);
    this.setState({ openDeleteConfirmPopup: false, currentSelectedRow: {} });
  };

  handleCheckBoxClick = (e, id) => {
    let { selectedRow } = this.state;
    if (selectedRow && selectedRow.includes(id)) {
      if (selectedRow.length > 0) {
        const index = selectedRow.indexOf(id);
        if (index > -1) {
          selectedRow.splice(index, 1);
        }
      }
    } else {
      if (id) {
        selectedRow.push(id);
      }
    }
    this.setState({ selectedRow: selectedRow });
  };

  addDocumentType = () => {
    var me = this;
    let {
      name,
      note,
      selectedRow,
      selectedEmailTemplate,
      isDocumentTypeCheck,
      docValue,
      fileList,
    } = this.state;

    if (name == "") {
      alert("Document Type should not blank.");
      return;
    }

    if (name == "Other" || name == "Payroll Check" || name == "8879") {
      alert("Document Type already exist");
      return;
    }
    let body = {
      name: name,
      note: note,
      mailing_list_ids: selectedRow,
      email_template: selectedEmailTemplate,
      isSave: isDocumentTypeCheck,
    };

    let url = `/api/documentUpload/addDocUploaderType`;
    let formData = new FormData();
    formData.append("name", name);
    formData.append("note", note);
    formData.append("mailing_list_ids", selectedRow);
    formData.append("email_template", selectedEmailTemplate);
    formData.append("isSave", isDocumentTypeCheck);
    if (fileList.length > 0) {
      fileList.map((file) => {
        //For multiple file upload
        formData.append("files", file);
      });
    }
    let options = {
      method: "POST",
      headers: {
        token: this.props.token,
        //Accept: 'application/json',
        //'Content-Type': 'application/json'
        //'Content-Type': 'multipart/form-data'
      },
      //body: JSON.stringify(body)
      body: formData,
    };
    fetch(url, options).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        if (res.message == "Document type already exist.") {
          this.notifyFormError(res, "Document type is already exist.");
        } else {
          me.props.showPackageList();
          if (isDocumentTypeCheck) {
            alert("Document Type saved successfully and sent email.");
          } else {
            alert("Email sent successfully.");
          }
        }
      } else {
        this.notifyFormError(res, "Internal server error.");
        this.setState({ open: false });
      }
    });
  };

  checkButtonFormatter(cell, row) {
    return (
      <Checkbox
        color="primary"
        checked={
          this.state.selectedRow && this.state.selectedRow.includes(row._id)
            ? true
            : false
        }
        onClick={(event) => this.handleCheckBoxClick(event, row._id)}
      />
    );
  }

  editButtonFormatter(cell, row) {
    return (
      <IconButton
        onClick={this.showCreateMailing}
        style={{ width: "25px", height: "25px" }}
      >
        <p data-tip="Edit" data-for="editGroup">
          <img src={editDefaultIcon} />
        </p>
        <ReactTooltip id="editGroup" />
      </IconButton>
    );
  }

  deleteButtonFormatter(cell, row) {
    return (
      <IconButton
        onClick={() => {
          this.deleteMailingTypeListUser(row);
        }}
        style={{ width: "25px", height: "25px" }}
      >
        <p data-tip="Delete" data-for="deleteGroup">
          <img src={deleteDefaultIcon} />
        </p>
        <ReactTooltip id="deleteGroup" />
      </IconButton>
    );
  }

  // This method is used for searching
  submitSearchForm(searchText) {
    var me = this;
    if (searchText != "" && searchText != null) {
      this.props.navigation({}, "SHOW_MAILING_LIST", searchText.trim());
      this.setState({ isLoading: false, searchTextValue: searchText });
    } else {
      this.setState({ searchTextValue: "" });
      this.props.navigation({}, "SHOW_MAILING_LIST", "");
    }
  }

  clearSearchText = () => {
    this.setState({ searchTextValue: "", open: false });
    this.getAllCompanies();
  };

  renderTable() {
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let { mailingTypeList } = this.props;
      return (
        <div style={{ overflowY: "inherit", width: "95%", margin: "0 auto" }}>
          <div>
            <div>
              <div
                className="searchTextCls"
                style={{ display: "inline-block" }}
              >
                <input
                  type="text"
                  value={this.state.searchTextValue}
                  className="searchInputCls"
                  placeholder="Search"
                  onChange={(e) => this.submitSearchForm(e.target.value)}
                />
                <span
                  className="searchImgCls"
                  onClick={() => {
                    this.clearSearchText();
                  }}
                >
                  <img src={searchIcon} style={{ width: "16px" }} />
                </span>
              </div>
              <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                <Link
                  onClick={this.showCreateMailing}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={CreateMailingListIcon}
                    style={{ width: "16px", marginRight: "5px" }}
                  />
                  Create Mailing List
                </Link>
              </div>
            </div>
            <BootstrapTable data={mailingTypeList} bordered={false} pagination>
              <TableHeaderColumn
                dataField="button"
                dataFormat={this.checkButtonFormatter}
                width="20"
              ></TableHeaderColumn>
              <TableHeaderColumn isKey={true} dataField="name" width="200">
                Group Name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={this.editButtonFormatter}
                width="20"
              ></TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={this.deleteButtonFormatter}
                width="20"
              ></TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
      );
    }
  }

  closeDeleteConfirmPopup = () => {
    this.setState({ openDeleteConfirmPopup: false });
  };

  resetForm() {
    this.setState({
      fileList: [],
      response: "",
      isLoading: false,
      message: "Click to upload file, or drag and drop file",
    });
  }

  onDrop(e) {
    var me = this;
    if (e.length > 0) {
      let fList = [];
      e.forEach(function (fileData, index) {
        fList.push(fileData);
        if (index == e.length - 1) {
          me.setState({ fileList: fList, message: "" });
        }
      });
    } else {
      this.setState({ message: `Invalid File` });
    }
  }

  renderContent() {
    let { response, isLoading } = this.state;
    let { zone, activeZone, centerStyle } = this.state.styles;

    if (isLoading) {
      let size = window.screen.width / 7;
      return <CircularProgress color={"#424242"} size={size} thickness={20} />;
    }
    return (
      <div style={{ padding: "2rem" }}>
        <Dropzone
          onDrop={this.onDrop}
          disablePreview={true}
          style={zone}
          activeStyle={activeZone}
        >
          <center>
            {this.state.fileList.length > 0 ? (
              this.state.fileList.map((file, index) => {
                return (
                  <h4
                    className="uploadAttachmentTextAlign"
                    style={{ color: "#000" }}
                  >
                    {file.name}
                  </h4>
                );
              })
            ) : (
              <h4 className="uploadAttachmentTextAlign">
                {this.state.message}
              </h4>
            )}
          </center>
        </Dropzone>
      </div>
    );
  }

  handleChange = (value) => {
    this.setState({ selectedEmailTemplate: value });
  };

  onNoteChangeValue = (value) => {
    this.setState({ note: value });
  };

  onDocumentNameChangeValue = (value) => {
    this.setState({ name: value });
  };

  onDocumentTypeCheck = () => {
    if (!this.state.isDocumentTypeCheck) {
      this.setState({ isDocumentTypeCheck: true });
    } else {
      this.setState({ isDocumentTypeCheck: false });
    }
  };

  showPackageList = () => {
    this.props.showPackageList();
  };

  showMailingListMethod() {
    this.setState({ createMailingListFlag: false });
    this.props.getAllMailingType();
  }

  render() {
    let { openDeleteConfirmPopup, name, createMailingListFlag } = this.state;
    let { open } = this.props;

    return (
      <div>
        <div
          style={{ display: open && !createMailingListFlag ? "block" : "none" }}
        >
          <div style={{ margin: "0.5em" }}>
            <div
              style={{ display: "inline-block", verticalAlign: "middle" }}
              className="genericUploaderBackIconCls"
            >
              <IconButton
                aria-label="close"
                style={{ width: "25px" }}
                onClick={this.showPackageList}
              >
                <img
                  src={backIcon}
                  style={{ width: "16px", marginRight: "5px" }}
                />
              </IconButton>
            </div>
            <div style={{ display: "inline-block", verticalAlign: "middle" }}>
              <span className="companyListTitle">
                {name ? name : "Email Porter"}
              </span>
            </div>
          </div>
          <div
            className="row"
            style={{ height: "calc(100vh - 20px)", margin: "0.5em" }}
          >
            <div
              className="column d-flex align-items-stretch"
              style={{ backgroundColor: "#fff" }}
            >
              <div>
                <div
                  style={{
                    backgroundColor: "#fff",
                    paddingLeft: "2rem",
                    borderRadius: "5px",
                  }}
                >
                  <SelectField
                    floatingLabelText="Select Email Template"
                    value={this.state.selectedEmailTemplate}
                    style={{ backgroundColor: "#fff", width: "60%" }}
                  >
                    {sendgridTemplateList && sendgridTemplateList.length
                      ? sendgridTemplateList.map(
                          (sendgridTemplateListData, index) => {
                            return (
                              <MenuItem
                                key={"welcome_" + index}
                                onClick={() => {
                                  this.handleChange(
                                    sendgridTemplateListData.id,
                                  );
                                }}
                                value={sendgridTemplateListData.id}
                                primaryText={sendgridTemplateListData.name}
                              />
                            );
                          },
                        )
                      : ""}
                  </SelectField>
                </div>
                <br />
                <label style={{ paddingLeft: "1.5rem" }}>
                  {" "}
                  Contact Mailing List
                </label>
                {this.renderTable()}
              </div>
            </div>
            <div className="column d-flex align-items-stretch rightMainDiv">
              <div>
                <Formsy.Form ref="form">
                  <FormsyText
                    multiLine
                    name="note"
                    placeholder="Note..."
                    value={this.state.note}
                    onChange={(e) => this.onNoteChangeValue(e.target.value)}
                    style={{
                      width: "93%",
                      marginLeft: "2rem",
                      marginBottom: "0",
                      height: "70px",
                      border: "1px solid #ccc",
                      padding: "10px",
                      marginTop: "0px",
                      maxHeight: "90px",
                    }}
                  />
                </Formsy.Form>
              </div>
              {this.renderContent()}
              <div
                style={{
                  float: "right",
                  marginTop: "1rem",
                  position: "absolute",
                  paddingLeft: "24px",
                }}
              >
                <Formsy.Form
                  ref="form1"
                  style={{ width: "26rem", display: "inline-block" }}
                >
                  <div className="row" style={{ display: "inline-flex" }}>
                    <div className="column" style={{ width: "10%" }}>
                      <Checkbox
                        color="primary"
                        checked={this.state.isDocumentTypeCheck}
                        onClick={(event) => this.onDocumentTypeCheck()}
                      />
                    </div>
                    <div className="column documentTypeNameCls">
                      <FormsyText
                        name="documentType"
                        placeholder="Document Name"
                        value={this.state.name}
                        onChange={(e) =>
                          this.onDocumentNameChangeValue(e.target.value)
                        }
                        style={{
                          width: "20rem",
                          height: "20px",
                          borderBottom: "1px solid #ddd !important",
                        }}
                      />
                    </div>
                  </div>
                </Formsy.Form>
                <FlatButton onClick={this.resetForm} className="flatButtonCls">
                  Reset
                </FlatButton>
                <FlatButton
                  onClick={this.addDocumentType}
                  style={{ marginLeft: "2rem" }}
                  className="flatButtonCls"
                >
                  Submit
                </FlatButton>
              </div>
            </div>
          </div>

          <Dialog
            title="Delete Mailing type"
            open={openDeleteConfirmPopup}
            onRequestClose={this.closeDeleteConfirmPopup}
            style={{ width: "50%", textAlign: "center" }}
          >
            Are you sure you want to delete this mailing list?
            <br />
            <br />
            <FlatButton
              type="button"
              className="flatButtonCls"
              onTouchTap={this.deleteMailingType}
            >
              Yes
            </FlatButton>
            <FlatButton
              type="button"
              style={{ marginLeft: "2rem" }}
              className="flatButtonCls"
              onTouchTap={this.closeDeleteConfirmPopup}
            >
              No
            </FlatButton>
          </Dialog>
        </div>
        <CreateMailingList
          open={createMailingListFlag}
          mailingType={this.state.mailingTypeData}
          snackbar={this.props.snackbar}
          mailingTypeUserList={this.state.mailingTypeUserList}
          showMailingListMethod={this.showMailingListMethod}
          token={this.props.token}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/documentUploader/ShowMailingList.js